import React from 'react'
import { LIBERTY_IMAGES } from '../assets/asset'

const Footer = () => {
    return (
        <>
            <footer className="relative z-11 bottom-0 left-0 right-0 row-start-3 flex flex-col gap-2 items-center justify-center py-2 pb-[100px] md:pb-2">
                <a
                    href="https://docs.libertyswap.finance/general-information/terms-of-service#id-7.-legal-compliance-and-regulatory-considerations"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-xs mb-2 font-semibold hover:text-amber-500 transition-colors cursor-pointer"
                >
                    Disclaimer
                </a>
                <div className="text-xs text-gray-400 mb-2">
                    Copyright © 2025. All Rights Reserved.
                </div>
                <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center text-xs mb-4 underline">
                    <a
                        href="https://docs.libertyswap.finance/how-liberty-swap-works/cross-chain-swaps#id-5.-smart-contract-addresses"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="hover:text-amber-500 transition-colors"
                    >
                        Contract Address
                    </a>
                </div>
                <div className="fixed bottom-2 right-2 md:bottom-8 md:right-8 flex flex-col items-end gap-2">
                    <a
                        href="https://x.com/LibertySwapFi"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-white hover:text-gray-200 transition-colors"
                    >
                        <div className="bg-gradient-to-r from-[#E71DE7] to-[#6335F8] rounded-full p-3">
                            <div className="flex items-center gap-2">
                                <img src={LIBERTY_IMAGES.X} alt="X" width={24} height={24} />
                                <span className="hidden md:inline">Need Help?</span>
                            </div>
                        </div>
                    </a>
                </div>
            </footer>
        </>
    )
}

export default Footer